import Request, { SimpleResponse } from './Request';

export interface IWeekPeriod {
    startDateW1: number;
    startDateW2: number;
    startDateW3: number;
    startDateW4: number;
    endDateW1: number;
    endDateW2: number;
    endDateW3: number;
    endDateW4: number;
}

class WeekPeriod {
    static GetForecast = (): IWeekPeriod => { return Request.DoGet('weekperiod/forecast') as unknown as IWeekPeriod; };
    static UpdateForecast = (data: IWeekPeriod): SimpleResponse => { return Request.DoPut('weekperiod/forecast', data) as unknown as SimpleResponse; };
    static GetSales = (): IWeekPeriod => { return Request.DoGet('weekperiod/sales') as unknown as IWeekPeriod; };
    static UpdateSales = (data: IWeekPeriod): SimpleResponse => { return Request.DoPut('weekperiod/sales', data) as unknown as SimpleResponse; };
}

export default WeekPeriod;